<template>
  <section class="thing-list">
    <all-projects-navigator @close="toggleOpenNavigator(false)"
                            @open="toggleOpenNavigator(true)"
                            @clickInNode="clickInNavigatorNode"
                            :isOpen="openNavigator"
                            navigatorLink="/things"
                            :subheaderText="$t('things.allThings')">
      <thingIcon fill-color="#109CF1" opacity="1"/>
    </all-projects-navigator>
    <router-view class="things-body"
                 v-if="projects"
                 :class="{'things-body_close': !openNavigator}"></router-view>
    <main class="things-body"
          v-if="!routeId"
          :class="{'things-body_close': !openNavigator}">
      <thing-list-header></thing-list-header>
      <things-first></things-first>
    </main>

  </section>
</template>

<script>
  import {tokenAndRoute} from "../../../../mixins/utils/tokenAndRoute";
  import {generateGrid} from "../../../../mixins/generateGrid";
  import {projectsNavigator} from "../../../../mixins/utils/projectsNavigator";
  import thingIcon from '../../../Svg/journal/thingIcon'
  import thingListHeader from '../Headers/thingsList/thingListHeader'
  import thingsFirst from './thingFirstLevel'
  import {mapMutations, mapState} from "vuex";

  export default {
    name: 'thingsList',
    mixins: [tokenAndRoute, projectsNavigator, generateGrid],
    components: {
      thingListHeader,
      thingsFirst,
      thingIcon
    },
    data() {
      return {
        layoutThings: [],
      }
    },
    computed: {
      ...mapState({
        projects: state => state.projects.allProjects
      }),
    },
    watch: {

    },
    methods: {
      ...mapMutations({
        setDirName: 'things/SET_DIR_NAME'
      }),
      clickInNavigatorNode(node) {
        let id = node.id;
        this.setDirName(node.name) //?????  как передать в стейт?

        /*if (node.type === 'group') {
          this.$router.push('/things/group/' + id)
        } else if (node.type === 'virtual') {
          this.$router.push('/things/multithing/' + id)
        } else {
          this.$router.push('/things/thing/' + id);
        }*/
        let projectId
        let treeItem
        let findParent = (item) => {
          treeItem = item.parent
          if (item.parent.id !== 0) {
            projectId = item.parent.id
            findParent(treeItem)
          }
        }

        findParent(node)

        if (node.isMother) {
          this.$router.push(`/things/project/${id}`)
        } else {
          this.$router.push(`/things/project/${projectId}/project-item/${id}`)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .things-body {
    margin-left: 300px;
    position: relative;
    height: 100%;

    @media screen and (max-width: 1500px) {
      margin-left: 250px;
    }

    @media screen and (max-width: 1370px) {
      margin-left: 200px;
    }
  }

  .things-body_close {
    margin-left: 70px;
  }

  .thing-list {
    min-height: calc(100vh - 90px - 50px);
  }


</style>
